export default __webpack_public_path__ + "static/media/ball2.37dbb699.webp";